import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export default function KPIAvgStationaryDaysListItem(props){
    console.debug("RTS Break KPIAvgStationaryDaysListItem");

    return (
        <TableRow>
            <TableCell>{props.data.prodName} ({props.data.prodNum})</TableCell>
            <TableCell align="right" sx={{width:"75px", fontWeight:props.data.desc==='Total'?'bold':'normal'}}>{new Intl.NumberFormat('en-US').format(props.data.days.toFixed(0))}</TableCell>
        </TableRow>
    )
}

